import {
  Card,
  CaptionedImage,
  ClassicCard,
  ControlCard,
  ImageOnly,
} from "../index.js";
import {
  dateFromUnixTimestamp as l,
  rehydrateDateAfterJsonization as w,
} from "../../util/date-utils.js";
import { logger as r } from "../../../shared-lib/index.js";
export function newCard(n, e, t, o, i, l, u, d, a, w, f, s, m, C, p, c, x, F) {
  let j;
  if (e === Card.it.Pt || e === Card.it.Ut)
    j = new ClassicCard(n, t, o, i, l, u, d, a, w, f, s, m, C, p, c, x);
  else if (e === Card.it.st)
    j = new CaptionedImage(n, t, o, i, l, u, d, a, w, f, s, m, C, p, c, x);
  else if (e === Card.it.Gt)
    j = new ImageOnly(n, t, i, u, d, a, w, f, s, m, C, p, c, x);
  else {
    if (e !== Card.it.Xt)
      return r.error("Ignoring card with unknown type " + e), null;
    j = new ControlCard(n, t, d, w, C, p);
  }
  return F && (j.test = F), j;
}
export function newCardFromContentCardsJson(n) {
  if (n[Card._t.Ot]) return null;
  const e = n[Card._t.ht],
    r = n[Card._t.Z],
    t = n[Card._t.et],
    o = n[Card._t.rt],
    i = n[Card._t.ot],
    u = n[Card._t.ct],
    d = l(n[Card._t.nt]),
    a = d;
  let w;
  w = n[Card._t.lt] === Card.Mt ? null : l(n[Card._t.lt]);
  return newCard(
    e,
    r,
    t,
    o,
    i,
    u,
    a,
    d,
    null,
    w,
    n[Card._t.URL],
    n[Card._t.ft],
    n[Card._t.xt],
    n[Card._t.bt],
    n[Card._t.gt],
    n[Card._t.jt],
    n[Card._t.zt],
    n[Card._t.kt] || !1,
  );
}
export function newCardFromFeedJson(n) {
  return newCard(
    n.id,
    n.type,
    n.viewed,
    n.title,
    n.image,
    n.description,
    l(n.created),
    l(n.updated),
    n.categories,
    l(n.expires_at),
    n.url,
    n.domain,
    n.aspect_ratio,
    n.extras,
    !1,
    !1,
  );
}
export function newCardFromSerializedValue(n) {
  return (
    newCard(
      n[Card.tt.ht],
      n[Card.tt.Z],
      n[Card.tt.et],
      n[Card.tt.rt],
      n[Card.tt.ot],
      n[Card.tt.ct],
      w(n[Card.tt.dt]),
      w(n[Card.tt.nt]),
      n[Card.tt.ut],
      w(n[Card.tt.lt]),
      n[Card.tt.URL],
      n[Card.tt.ft],
      n[Card.tt.xt],
      n[Card.tt.bt],
      n[Card.tt.gt],
      n[Card.tt.jt],
      n[Card.tt.zt],
      n[Card.tt.kt] || !1,
    ) || void 0
  );
}
